import { Tile } from 'ia-react-core';
import styled from 'styled-components';

export const StyledTile = styled(Tile)`
 h4 {
  line-height: 26px;
}
`;
